<div id="loaderitem" class="loaderitem" *ngIf="loading$ | async">
</div>
<div class="loader-content" *ngIf="loading$ | async">
    <img class="loader-content__seat-loader" src="assets/images/seat-loader.svg">
</div>